export default "__VITE_PUBLIC_ASSET__2526fd68__"